/*
 *
 * GlobalNavBar constants
 *
 */

export const SET_USER_INPUT = "app/GlobalNavBar/SET_USER_INPUT";

export const starRatingsTitleMap = {
  5: "5 stars",
  4: "4 stars or more",
  3: "3 stars or more",
  2: "2 stars or more",
  1: "1 star",
};

export const tensRatingsTitleMap = {
  10: "10 points",
  9: "9 or greater",
  8: "8 or greater",
  7: "7 or greater",
  6: "6 or greater",
  5: "5 or greater",
  4: "4 or greater",
  3: "3 or greater",
  2: "2 or greater",
  1: "1 or greater",
};

export const thumbsRatingsTitleMap = {
  0.9: "90% Thumbs up or higher",
  0.8: "80% Thumbs up or higher",
  0.7: "70% Thumbs up or higher",
  0.6: "60% Thumbs up or higher",
  0.5: "50% Thumbs up or higher",
};

export const routesMap = {
  "/": "dashboard",
  "/dashboard": "dashboard",
  "/jobs": "jobs",
  "/jobpost": "jobs",
  "/jobpost/tests": "jobs",
  "/jobpost/jobtitle": "jobs",
  "/jobpost/automation": "jobs",
  "/jobpost/link": "jobs",
  "/landingpages": "manage",
  "/landingpages_form": "manage",
  "/landingpages_form_v2": "manage",
  "/results": "results",
  "/exitpages": "manage",
  "/exitpages_form": "manage",
  "/ratings": "manage",
  "/testmaker": "manage",
  "/emailtemplates": "manage",
  "/emailtemplate_form": "manage",
  "/testbatteries": "manage",
  "/pipelines": "manage",
  "/accessroles": "settings",
  "/jobapplications": "manage",
  "/users": "settings",
  "/jobapplications_form": "manage",
  "/jobapplications_questions": "manage",
  "/teams": "settings",
  "/companypreferences": "settings",
  "/analytics": "analytics",
  "/reports": "manage",
  "/userpreferences": "settings",
  "/reports_data_form": "manage",
  "/ratings_form": "manage",
  "/reports_aggregate_form": "manage",
  "/reports_data_results": "manage",
  "/reports_aggregate_results": "manage",
  "/schedule_candidates": "jobs",
  "/testmaker_form": "manage",
  "/testmaker_typing_form": "manage",
  "/testmaker_questions": "manage",
  "/testmaker_analytics": "manage",
  "/subscribe": "settings",
  "/payment": "settings",
  "/jobapplicationfilters": "manage",
  "/pricing": "settings",
  "/pipelines_form": "manage",
  "/testportfolio": "help",
  "/testmaker_create_questions": "manage",
  "/search": "results",
  "/integrations": "settings",
  "/ziprecruiter": "settings",
  "/ziprecruiter_success": "settings",
  "/integrations_order_form": "settings",
  "/versionsinfo": "settings",
  "/ziprecruiter_purchase": "settings",
  "/versionupgrade": "settings",
  "/version_upgrade_payment": "settings",
  "/ziprecruiter_upgrade": "settings",
  "/ziprecruiter_upgrade_payment": "settings",
  "/add_ziprecruiter_payment": "settings",
  "/testbatteries_form": "manage",
  "/updates": "help",
  "/resources": "help",
  "/faq": "help",
  "/howtoguides": "help",
  "/candidate": "results",
  "/resultslanding": "results",
  "/interviewTemplates": "manage",
  "/interviewTemplates_form": "manage",
};
